module.exports = __webpack_public_path__ + "static/media/PW.b805f38a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PW.svg
// module id = 2245
// module chunks = 7